var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chart-wrapper" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center mb-4" },
      [
        _vm.title
          ? _c("h4", { staticClass: "font-weight-bold mb-0" }, [
              _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex h-100" },
          _vm._l(_vm.chartData.datasets, function (dataset, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "card shadow-none d-flex flex-row align-items-center py-1 mb-0",
                class:
                  index !== _vm.chartData.datasets.length - 1 ? "mr-4" : "",
              },
              [
                _c("div", {
                  staticClass: "p-1 m-2 rounded-sm",
                  style: {
                    backgroundColor:
                      dataset.borderColor || dataset.backgroundColor,
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "mx-2" }, [
                  _vm._v(_vm._s(dataset.label)),
                ]),
              ]
            )
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticStyle: { height: "250px" } }, [
      _c("canvas", { ref: "canvas" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }